// extracted by mini-css-extract-plugin
export default {"button":"style_button__3eN4S","modal":"style_modal__M+UUC"};